module.exports = "<div class=\"register-container\">\n  <div class=\"header-image\">\n    <div class=\"logo\">\n      <img src=\"/assets/img/relief-logo-navy.svg\" title=\"Relief Telemed Logo\" />\n    </div>\n  </div>\n  <div class=\"header-row\">\n    <h2 translate>Register to Be a Relief Provider</h2>\n    <h3 translate>We're excited you're joining us!</h3>\n  </div>\n\n  <step-1 *ngIf=\"step === '1'\"></step-1>\n\n  <step-2 *ngIf=\"step === '2'\"></step-2>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/register/register.component.html
// module id = ./src/app/register/register.component.html
// module chunks = main